export const constants = {
  //baseUrl: '' + process.env.URL,
  // baseUrl: 'https://dev-vardi.bio.credit/api',
  // baseUrl: 'https://app-vardi.bio.credit/api',
  baseUrl: process.env.VUE_APP_URL,
  endPoints: {
    settings: "/settings",
    storeContact: "/store-contact",
    isRegistered: "/is-registered",
    paymentRequest: "/pay",
    paymentBanks: "/v2/payment-banks",
    paymentLink: "/v2/payment-link",
    paymentRequestCash: "/payment_reference",
    validateDocuments: "/validate-documents",
    registerUser: "/register-user",
    login: "/login",
    user: "/user",
    form: "/form",
    validateFullForm: "/validate-full-form",
    saveForm: "/save-field-value",
    policies: "/insurance-policies",
    simulator: "/simulator",
    phoneIsRegistered: "/phone-is-registered",
    registerPhone: "/register-phone",
    validatePhone: "/validate-phone",
    createRequest: "/create-request",
    signDocuments: "/sign-documents",
    signDocument: "/sign-document",
    reSendSignatureOtp: "/re-send-signature-otp",
    startPayment: "/start-payment",
    manualValidateDocuments: "/manual-validate-documents",
  },
  paymentDays: [
    {
      minDay: 1,
      maxDay: 7,
      day: 4,
    },
    {
      minDay: 8,
      maxDay: 14,
      day: 8,
    },
    {
      minDay: 15,
      maxDay: 21,
      day: 15,
    },
    {
      minDay: 22,
      maxDay: 31,
      day: 22,
    },
  ],
};

export const formatCurrency = function (value) {
  const formatter = new Intl.NumberFormat("es-CO", {
    currency: "COP",
    style: "currency",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(value);
};

export const formatNumber = function (value) {
  const formatter = new Intl.NumberFormat("es-CO", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(value);
};

export const formatDecimal = function (value) {
  return Math.ceil(value);
};

export const addDays = function (date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const formatDate = function (date) {
  let _date;
  if (typeof date === "string") {
    const [year, month, day] = date.split("-").map(Number);
    _date = new Date(year, month - 1, day); // Mes 0-indexado
  } else {
    _date = date;
  }

  return _date.toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatDateCo = function (date) {
  let _date;
  if (typeof date === "string") {
    const [year, month, day] = date.split("-").map(Number);
    _date = new Date(year, month - 1, day); // Mes 0-indexado
  } else {
    _date = date;
  }
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const dia = _date.getDate();
  const mes = meses[_date.getMonth()];
  const año = _date.getFullYear();

  return `${dia} de ${mes} ${año}`;
};
